import {
  SHARED_NAV_ITEMS,
  NEW_LAYOUT_NAV_ITEMS,
  SHARED_NAV_ITEMS_HREFS,
  SHARED_NAV_ITEMS_TEXTS,
} from '../constants/nav-items';
import { t } from '../i18n';
import { NavItem } from '../types';

interface NavigationBarConfig {
  tenant: string;
  logged: boolean;
  showLoyaltyItem: boolean;
  showNotificationItem: boolean;
  epicOmni948?: boolean;
  epicOmni1546?: boolean;
  displayNewLayout?: boolean;
}

export const getNavItems = (config: NavigationBarConfig): NavItem[] => {
  const {
    logged,
    showLoyaltyItem,
    showNotificationItem,
    epicOmni948,
    epicOmni1546,
    displayNewLayout,
  } = config;
  let _navItems = displayNewLayout ? NEW_LAYOUT_NAV_ITEMS : SHARED_NAV_ITEMS;
  if (!logged) {
    _navItems = _navItems.filter((nav) => nav.anonymous);
  }

  if (logged && !showLoyaltyItem) {
    _navItems = _navItems.filter((nav) => nav.contentName != 'viewLoyalty');
  }

  if (logged && !epicOmni1546) {
    _navItems = _navItems.filter((nav) => nav.contentName != 'viewWishList');
  }

  if (epicOmni948) {
    // find index of notification menu in navItems
    const notiItemIndex = _navItems.findIndex(
      (navItem) => navItem.text === SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
    );
    // check if notification menu exists in navItems (if true, index return will >= 0)
    if (notiItemIndex >= 0) {
      // modify href of notification menu to point to promotion & update notification screen.
      // add new menus as children: promotion & update and orders.
      const newNotiItem: NavItem = {
        ..._navItems[notiItemIndex],
        href: SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI,
        children: [
          {
            icon: <div style={{ width: '18px', height: '18px' }}></div>,
            text: SHARED_NAV_ITEMS_TEXTS.PROMOTION_AND_UPDATE_NOTI,
            href: SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI,
            fallbackHref: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
            anonymous: true,
            showByConfiguration: true,
            contentName: 'viewPromotionAndUpdateNotification',
            regionName: 'headerBar',
          },
          {
            icon: <div style={{ width: '18px', height: '18px' }}></div>,
            text: SHARED_NAV_ITEMS_TEXTS.ORDERS_NOTI,
            href: SHARED_NAV_ITEMS_HREFS.ORDERS_NOTI,
            anonymous: true,
            showByConfiguration: true,
            contentName: 'viewOrdersNotification',
            regionName: 'headerBar',
          },
        ],
      };
      _navItems[notiItemIndex] = newNotiItem;
    }
  }

  return _navItems
    .filter(
      (nav) =>
        !nav.showByConfiguration ||
        (nav.showByConfiguration && showNotificationItem),
    )
    .map((item) => {
      return !!item.children && !!item.children.length
        ? {
            ...item,
            text: t(item.text),
            children: item.children.map((childrenItem) => ({
              ...childrenItem,
              text: t(childrenItem.text),
            })),
          }
        : { ...item, text: t(item.text) };
    });
};
